import { Box, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import PointsBox from "../../components/PointsBox";
import { logoWhite, ratLogo } from "../../components/SmallComponents/Images";

const commentsPointObj = {
  view: 1,
  like: 5,
  comment: 10,
  retweet: 15,
  quoteRetweet: 20,
};

const postPointObj = {
  view: 1,
  like: 25,
  comment: 50,
  retweet: 75,
  quoteRetweet: 100,
};

const engagementPointObj = {
  like: 2,
  comment: 5,
  retweet: 10,
  quoteRetweet: 15,
};

const headingStyle = {
  fontFamily: "Saira Semi Condensed",
  fontWeight: 800,
  fontSize: { xs: "24px", sm: "30px" },
  lineHeight: "25px",
  color: "#ffffff",
  letterSpacing: "1px",
  textAlign: { xs: "center", md: "left" },
  textTransform: "uppercase",
};
const paraStyle = {
  fontFamily: "Montserrat",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "36px",
  textAlign: { xs: "center", md: "left" },
  color: "#ffffff",
  textTransform: "uppercase",
};

function PointsBreakdown() {
  const matches = useMediaQuery("(max-width:900px)");

  return (
    <Box mt={10} mx={{ xs: 2, md: 4 }}>
      <Grid container spacing={{ xs: 3, md: 8 }}>
        <Grid item xs={12} md={6}>
          <Stack gap={3}>
            <Box>
              <Typography variant="h3" sx={headingStyle}>
                Points Breakdown
              </Typography>
              <Typography variant="body1" sx={paraStyle} my={3}>
                Any tweet that is posted using our ticker $BGAI will begin
                earning points based on the criteria
              </Typography>
            </Box>
            <PointsBox heading={"Post point system"} data={postPointObj} />
            {!matches && (
              <Box my={3}>
                <Typography variant="h3" sx={headingStyle}>
                  Successful $BGAI
                </Typography>
                <Typography variant="body1" sx={paraStyle} my={3}>
                  50% of tweet performanceOn top of earning points for
                  commenting, users will also earn an additional bonus for
                  successfully ratioing a Tweet. A Successful ratio consists of
                  getting more likes than an original tweet. A comment that
                  successfully ratios a tweet will earn 50% of the original
                  tweets points.
                </Typography>
              </Box>
            )}
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack gap={3}>
            <PointsBox
              heading={"Comment point system"}
              data={commentsPointObj}
            />
            <PointsBox
              heading={"Engager point system"}
              data={engagementPointObj}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 2,
              }}
            >
              <Box component={"img"} alt="" src={logoWhite} width="140px" />
            </Box>
            {matches && (
              <Box mt={2}>
                <Typography variant="h3" sx={headingStyle}>
                  Successful $BGAI
                </Typography>
                <Typography variant="body1" sx={paraStyle} my={3}>
                  50% of tweet performanceOn top of earning points for
                  commenting, users will also earn an additional bonus for
                  successfully ratioing a Tweet. A Successful ratio consists of
                  getting more likes than an original tweet. A comment that
                  successfully ratios a tweet will earn 50% of the original
                  tweets points.
                </Typography>
              </Box>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PointsBreakdown;
